import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { BsModalService, ModalDirective } from 'ngx-bootstrap/modal';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

import { NoSpaceOnlyValidation } from '../../custom-validators/no-space-only-validation';
import { ProductDelistEnum, ProductRestrictEnum, ProductTypeEnum } from '../../enum/product-type.enum';
import { PromotionItemTypeEnum } from '../../enum/promotion.enum';
import { AlertModalComponent } from '../../layouts';
import { PromotionItem, PromotionTypeEnum } from '../../models';
import { BarcodeListSearchCriteria, BarcodeResponse } from '../../models/barcode.model';
import { BarcodeService } from '../../services';
import { AppStates } from '../../store/state/app.states';

@Component({
  selector: 'app-search-barcode-modal',
  templateUrl: './search-barcode-modal.component.html',
  styleUrls: ['./search-barcode-modal.component.scss']
})
export class SearchBarcodeModalComponent implements OnInit {
  @ViewChild('selectBarcodeModal') selectBarcodeModal: ModalDirective;
  @ViewChild('barcodeInput') barcodeInput: ElementRef;
  @Output() addItem = new EventEmitter<PromotionItem[] | BarcodeResponse[]>(); // TODO Fixing type of any to specified type
  @Input() allowProductType?: ProductTypeEnum = ProductTypeEnum.ALL;
  @Input() allowRestrictItem?: ProductRestrictEnum = ProductRestrictEnum.YES;
  @Input() allowDelistItem?: ProductDelistEnum = ProductDelistEnum.NO;
  @Input() promotion?: {
    promotionConRetailPrice: string;
    promotionType: PromotionTypeEnum;
    promotionItemType: PromotionItemTypeEnum;
  };

  public productType: ProductTypeEnum = ProductTypeEnum.INVENTORY;
  barcodeForm: UntypedFormGroup;
  submittedSelectBarcode: boolean;
  hasDuplicatedBarcode$: Observable<number>;
  duplicateError$: Observable<string>;
  maxLength = 200;

  constructor(
    protected readonly store: Store<AppStates>,
    private readonly formBuilder: UntypedFormBuilder,
    private readonly translate: TranslateService,
    protected readonly modalService: BsModalService,
    private readonly barcodeService: BarcodeService
  ) {
    this.barcodeForm = this.formBuilder.group({
      barcode: ['', [Validators.required, NoSpaceOnlyValidation]]
    });
  }

  ngOnInit() {
    // this.barcodeForm.patchValue({
    //   barcode: ''
    // });
  }

  get form() {
    return this.barcodeForm.controls;
  }

  closeSelectBarcodeModal() {
    this.barcodeForm.get('barcode').reset();
    this.submittedSelectBarcode = false;
    this.selectBarcodeModal.hide();
  }

  saveBarcode() {
    this.submittedSelectBarcode = true;
    if (this.barcodeForm.invalid) {
      return;
    }
    if (this.form.barcode.value) {
      const result = this.replaceEmptyString(this.form.barcode.value)
        .split(/\n/g)
        .filter(value => value !== '');

      if (result.length > this.maxLength) {
        this.alertErrorModal();
      } else if (result.length) {
        this.loadBarcodeData(result.join('\n'));
      } else {
        this.form.barcode.setValue('');
      }
    }
  }

  replaceEmptyString(input: string) {
    return input === null ? '' : input.replace(/^\n+|\n+$/g, '');
  }

  loadBarcodeData(barcodeString: string) {
    let searchCriteria: BarcodeListSearchCriteria;

    if (this.promotion) {
      searchCriteria = new BarcodeListSearchCriteria({ allowProductType: this.allowProductType });
    } else {
      searchCriteria = new BarcodeListSearchCriteria({
        allowRestrictItem: this.allowRestrictItem === ProductRestrictEnum.YES,
        allowDelistItem: this.allowDelistItem === ProductDelistEnum.YES,
        allowProductType: this.allowProductType,
        size: this.maxLength
      });
    }
    this.barcodeService
      .searchBarcodeByCriteria(barcodeString.split(/\n/), searchCriteria)
      .pipe(filter(data => Boolean(data) && Boolean(data.length)))
      .subscribe(response => {
        if (this.promotion) {
          const items: any[] = response.map(selectedItem => {
            return {
              barcode: selectedItem.barcode,
              articleNo: selectedItem.articleNo,
              productName: selectedItem.productName,
              unit: selectedItem.unit,
              unitFactor: selectedItem.unitFactor,
              movingAverage: selectedItem.movingAverage,
              retailPrice: selectedItem.retailPrice,
              vat: selectedItem.vat,
              discountCode: null,
              supplierCompensate: null,
              partnerCompensate: null,
              supplier: null,
              errorMessage: selectedItem.errorMessage
            };
          });

          this.addItem.emit(items);
        } else {
          this.addItem.emit(response);
        }

        this.closeSelectBarcodeModal();
      });
  }

  alertErrorModal() {
    this.barcodeForm.get('barcode').reset();
    this.selectBarcodeModal.hide();
    const initialState = {
      title: 'Failed',
      message: `File size limit exceeded (maximum size ${this.maxLength} records).`
    };

    this.modalService.show(AlertModalComponent, {
      initialState
    });
  }
}
